import React from "react";
import { useWebdoorController } from "modules/common/webdoor/webdoorControler";
import { usePromotionController } from "modules/common/sections/Promotions/promotionsControler";
import { useForYouController } from "modules/common/sections/ForYou/ForYouControler";
import { useForYourVehicleController } from "modules/common/sections/ForYourVehicle/ForYourVehicleControler";
import { Webdoor } from "modules/common/webdoor/webdoor";
import { HighlightedText } from "modules/common/HighlightedText/HighlightedText";
import styled from "@emotion/styled";
import bgNewHome from "assets/images/bg-new-home.png";
import { Promotions } from "modules/common/sections/Promotions/Promotions";
import { ForYou } from "modules/common/sections/ForYou/ForYou";
import { ForYourVehicle } from "modules/common/sections/ForYourVehicle/ForYourVehicle";

const MainStyled = styled.main`
  background: url(${bgNewHome}) center top no-repeat;
  background-attachment: fixed;
  background-size: 100%;
`
export default function HubHome() {
  const { webdoors, loading } = useWebdoorController()
  const { dataPromotions, loadingPromo } = usePromotionController()
  const { dataForYou, loadingForYou } = useForYouController()
  const { dataForYourVehicle, loadingForYourVehicle } = useForYourVehicleController()

  if ( loading || loadingPromo || loadingForYou || loadingForYourVehicle ) return <p>Carregando...</p>

  return (
    <MainStyled>
      <Webdoor webdoors={ webdoors } />
      <HighlightedText props={ HighlightedTextData } />
      <Promotions id="promocoes" dataPromotions={ dataPromotions } />
      <ForYou id="para-voce" dataForYou={dataForYou} />
      <ForYourVehicle id="para-seu-veiculo" dataForYourVehicle={dataForYourVehicle} />
    </MainStyled>
  );
}

// data HighlightedText
export const HighlightedTextData = {
  title: "PromoShell.",
  subtitle: "Promoções que seguem com você em todos os caminhos.",
  text: "Acompanhe as promoções da Shell conectadas às soluções que desenvolvemos para apoiar quem dirige, transformando tecnologia, cuidado e conveniência em escolhas mais seguras e tranquilas, na cidade ou na estrada.",
}